export var DEFAULT_SCROLL_DELAY = 250;